import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
footers: drilldownData["footers"].map(({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType }: ModuleFields) => ({
  name: name,
  type: formType,
  label: fieldName,
  placeholder: placeholder,
  validation: validation,
  className: className,
  loadOptions: loadOptions,
  usedFileType: usedFileType
}))
,

  footerweb: drilldownData["footerweb"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),
  socialMedia: drilldownData["socialMedia"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType, note, uploadTrigger }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note,
      uploadTrigger: uploadTrigger
    })
  ),
  aboutAndLegal: drilldownData["aboutAndLegal"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),
  servicePortals: drilldownData["servicePortals"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType, note, uploadTrigger }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note,
      uploadTrigger: uploadTrigger
    })
  ),

   

};